import CryptoJS from 'crypto-js'
import { createContext, useContext, useEffect, useMemo, useState } from 'react'

const LocalStorageContext = createContext(null)

const CONFIG_KEY = 'h2eqxE3eQTWfy0xJOR8IZKKPd634FLPN'

const TASKS_KEY = 'n8VUKHnp19SwY8ehfSnOeT0i2b6Ilf8y'

const SECRET_KEY = 'u£Il7dSC|Z}#(j[!/dG2fV`e£{u4GSA;{.Xf.?h5R$z`XQT6<5'

const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    return JSON.parse(decrypted)
  } catch {
    return null
  }
}

const encryptData = (data) => CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()

export const LocalStorageProvider = ({ children }) => {
  const [config, setConfig] = useState(null)

  const [tasks, setTasks] = useState([])

  const [localStorageLoaded, setLocalStorageLoaded] = useState(false)

  const clearHistory = () => {
    setConfig((previous) => {
      const newValues = { ...previous }
      newValues.history = []
      return newValues
    })
  }

  const initConfig = () => {
    setConfig({
      camera: null,
      debug: false,
      enableVoice: true,
      welcome: false,
      history: [],
    })
  }

  const setParam = (param, value) => {
    setConfig((previous) => {
      const newValues = { ...previous }
      newValues[param] = value
      return newValues
    })
  }

  const addHistory = (item) => {
    setConfig((previous) => {
      const newValues = { ...previous }
      if (!('history' in newValues)) {
        newValues.history = []
      }
      newValues.history.push(item)
      return newValues
    })
  }

  useEffect(() => {
    let tempConfig = {
      camera: 0,
      debug: false,
      enableVoice: true,
      welcome: false,
    }
    const storedConfig = localStorage.getItem(CONFIG_KEY)
    if (storedConfig) {
      const decrypted = decryptData(storedConfig)
      if (decrypted) {
        tempConfig = decrypted
      }
    }
    setConfig(tempConfig)

    tempConfig = []
    const storedTasks = localStorage.getItem(TASKS_KEY)
    if (storedTasks) {
      const decrypted = decryptData(storedTasks)
      if (decrypted) {
        tempConfig = decrypted
      }
    }
    setTasks(tempConfig)

    setLocalStorageLoaded(true)
  }, [])

  useEffect(() => {
    localStorage.setItem(CONFIG_KEY, encryptData(config))
  }, [config])

  useEffect(() => {
    localStorage.setItem(TASKS_KEY, encryptData(tasks))
  }, [tasks])

  const value = useMemo(() => ({
    addHistory,
    clearHistory,
    config,
    initConfig,
    localStorageLoaded,
    setConfig,
    setParam,
    setTasks,
    tasks,
  }), [config, localStorageLoaded, tasks])

  return (
    <LocalStorageContext.Provider value={value}>
      {children}
    </LocalStorageContext.Provider>
  )
}

export const useLocalStorage = () => {
  const context = useContext(LocalStorageContext)
  if (!context) {
    throw new Error('useLocalStorage must be used within a LocalStorageProvider')
  }
  return context
}
